/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from 'locales/translations';
import { _t } from 'utils/messages';

export const messages = {
  // someThing: () => _t(translations.someThing,'default value'),
  name: () => _t(translations.trackAssets.name),
  stocks: () => _t(translations.trackAssets.stocks),
  mutual: () => _t(translations.trackAssets.mutual),
  gold: () => _t(translations.trackAssets.gold),
  invested: () => _t(translations.trackAssets.invested),
  current: () => _t(translations.trackAssets.current),
  todayChange: () => _t(translations.trackAssets.todayChange),
  annualReturn: () => _t(translations.trackAssets.annualReturn),
  gain: () => _t(translations.trackAssets.gain),
  errorAccount: () => _t(translations.ViewAssets.errorAccount),
  errorAsset: () => _t(translations.ViewAssets.errorAsset),
  addAsset: () => _t(translations.ViewAssets.addAsset),
};
